import { render, staticRenderFns } from "./EmailTemplates.vue?vue&type=template&id=77454a77&scoped=true"
import script from "./EmailTemplates.vue?vue&type=script&lang=ts"
export * from "./EmailTemplates.vue?vue&type=script&lang=ts"
import style0 from "./EmailTemplates.vue?vue&type=style&index=0&id=77454a77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77454a77",
  null
  
)

export default component.exports